// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_89-0";
export var headerCellHover = "_89-1";
export var readCellContainer = "_89-2";
export var readCellSlot = "_89-3";
export var rowHoverCheckbox = "_89-4";
export var rowUnreadIndicator = "_89-5";
export var searchHighlight = "_89-8";
export var supportTicketRow = "_89-6";
export var unreadIndicator = "_89-7";